// we are storing the token in the local storage its using only when we use auth token instead of bearer token

const GetAccessToken = () => {
  const queryParams = new URLSearchParams(window.location.search);
  let accessToken = queryParams.get('token') || "";
  if (localStorage.getItem("accessToken")) {
    accessToken = localStorage.getItem("accessToken");
  }
  return accessToken;
};

export { GetAccessToken };
